export const DEFAULT_LOGIN_ERROR_MESSAGE =
  'An error occurred during log in, please try again.'
